/* Case Studio -- storefront touch-ups.
   1. Cart: shows the customer's own case preview as the cart thumbnail and
      adds an "Edit design" link back into the builder. Works on the cart page
      and in the cart drawer. No-ops on carts with no custom designs.
   2. Collection cards: prefixes the price of the made-to-order products, whose
      variants span a range, so the lowest price reads as a starting point. */
(function(){
"use strict";

var TAG = document.currentScript || document.querySelector("script[data-cs-builder]");
var BUILDER = (TAG && TAG.getAttribute("data-cs-builder")) || "/collections/build-your-case";
var LABEL = (TAG && TAG.getAttribute("data-cs-edit-label")) || "Edit design";
/* Shown in the Shopify admin on the order, hidden from the shopper's cart. */
var HIDE = ["preview", "artwork", "toprint"];

/* Everything this file and its neighbours add to the drawer. Changes inside
   these are ours, and must never send us back to the server. */
var OURS = ".cs-edit-link, .cart-upsell, .cart-skin__ship, .cart-skin__sub";

var PREFIX = (TAG && TAG.getAttribute("data-cs-price-prefix")) || "";
var HANDLES = ((TAG && TAG.getAttribute("data-cs-price-handles")) || "")
  .split(",")
  .map(function(s){ return s.replace(/\s/g, ""); })
  .filter(function(s){ return s.length > 0; });

var st = document.createElement("style");
st.textContent =
  ".cs-edit-link{display:inline-block;margin-top:.6rem;font-size:1.3rem;line-height:1.4;text-decoration:underline;text-underline-offset:.2rem;cursor:pointer}" +
  ".cs-thumb{display:block;width:100%;height:auto}" +
  ".ec-price .cs-from{font-weight:400!important}";
document.head.appendChild(st);

function rowIndex(row){
  var q = row.querySelector("[data-index]");
  if (!q) return null;
  var i = parseInt(q.getAttribute("data-index"), 10);
  return isNaN(i) ? null : i - 1;
}

function hideProp(row, name){
  var opts = row.querySelectorAll(".product-option");
  for (var i=0;i<opts.length;i++){
    var dt = opts[i].querySelector("dt");
    if (!dt) continue;
    var k = dt.textContent.replace(/[\s:]/g, "").toLowerCase();
    if (k === name) opts[i].style.display = "none";
  }
}

function decorate(cart){
  var rows = document.querySelectorAll(".cart-item");
  for (var n=0;n<rows.length;n++){
    var row = rows[n], i = rowIndex(row);
    if (i === null) continue;
    var item = cart.items[i];
    if (!item || !item.properties) continue;

    var prev = item.properties["Preview"] || item.properties["_Preview"] || "";
    var design = item.properties["_design"] || "";

    if (prev){
      var media = row.querySelector(".cart-item__media");
      if (media && !media.querySelector(".cs-thumb")){
        var img = media.querySelector("img");
        if (img){
          img.removeAttribute("srcset");
          img.removeAttribute("sizes");
          img.src = prev;
          img.className += " cs-thumb";
        } else {
          media.innerHTML =
            '<a href="' + (item.url || "#") + '" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>' +
            '<div class="cart-item__image-container gradient global-media-settings">' +
              '<img class="cart-item__image cs-thumb" src="' + prev + '" alt="" loading="lazy" width="150" height="188">' +
            '</div>';
        }
      }
      for (var h=0;h<HIDE.length;h++) hideProp(row, HIDE[h]);
    }

    if (design){
      var det = row.querySelector(".cart-item__details");
      if (det && !det.querySelector(".cs-edit-link")){
        /* Back to the builder this line was made in -- the product's own page,
           so a power bank never reopens in the phone case editor. */
        var base = item.url ? item.url.split("?")[0] : BUILDER;
        var a = document.createElement("a");
        a.className = "cs-edit-link link";
        a.href = base + (base.indexOf("?") > -1 ? "&" : "?") + "edit=" + encodeURIComponent(item.key);
        a.textContent = LABEL;
        det.appendChild(a);
      }
    }
  }
}

/* A custom case runs $23 on MagSafe and $27 on a lens finish, so the grid's
   lowest-price figure is true but reads as the only price. */
function prefixPrices(){
  if (!PREFIX || !HANDLES.length) return;
  for (var i=0;i<HANDLES.length;i++){
    var links = document.querySelectorAll('a[href*="/products/' + HANDLES[i] + '"]');
    for (var j=0;j<links.length;j++){
      var card = links[j].closest ? links[j].closest(".ec-card") : null;
      if (!card) continue;
      var p = card.querySelector(".ec-price");
      if (!p || p.querySelector(".cs-from")) continue;
      var s = document.createElement("span");
      s.className = "cs-from";
      s.textContent = PREFIX;
      p.insertBefore(s, p.firstChild);
    }
  }
}

/* The cart is re-read only when it can actually have changed. A short memory
   of the last answer keeps a burst of redraws down to one round trip, so the
   drawer never feels sticky while someone is using it. */
var busy = false, timer = null, last = 0, cached = null;
function run(){
  if (busy || !document.querySelector(".cart-item")) return;
  var now = Date.now();
  if (cached && now - last < 800){ decorate(cached); return; }
  busy = true;
  fetch("/cart.js", { headers: { "Accept": "application/json" }, credentials: "same-origin" })
    .then(function(r){ return r.json(); })
    .then(function(c){ if (c && c.items){ cached = c; last = Date.now(); decorate(c); } })
    .catch(function(){})
    .then(function(){ busy = false; });
}
function schedule(){ clearTimeout(timer); timer = setTimeout(run, 120); }

function watch(){
  prefixPrices();
  schedule();
  var targets = [];
  ["#main-cart-items", "cart-drawer", "cart-notification"].forEach(function(sel){
    var n = document.querySelector(sel);
    if (n) targets.push(n);
  });
  if (!targets.length) return;
  var mo = new MutationObserver(function(muts){
    for (var i=0;i<muts.length;i++){
      var t = muts[i].target;
      var node = t && t.nodeType === 1 ? t : (t && t.parentElement);
      if (node && node.closest && node.closest(OURS)) continue;
      schedule();
      return;
    }
  });
  targets.forEach(function(t){ mo.observe(t, { childList:true, subtree:true }); });
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch);
else watch();

})();
